//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CardTool",
  components: {},
  props: ["w", "h"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      col: 8
    };
  },
  computed: {
    pageSize: function pageSize() {
      return this.w * 3 * (this.h * 2);
    }
  },
  created: function created() {
    this.fetchList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/tool/toolPermitList", this.$qs.stringify({
        pageNum: 1,
        pageSize: this.pageSize
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;

          _this.$nextTick(function () {
            _this.computeCol();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 每次获取计算列个数
    computeCol: function computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;

        case 2:
          this.col = 4;
          break;

        case 3:
          this.col = 3;
          break;

        default:
          break;
      }
    },
    resizedEvent: function resizedEvent() {
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};